import React, { useMemo } from 'react';
import styled from 'styled-components';
import cn from 'classnames';
import ArrowLeft from '@crehana/crehana-icons/lib/NewArrowLeft';
import ArrowRight from '@crehana/crehana-icons/lib/NewArrowRight';
import ArrowLeftXS from '@crehana/crehana-icons/lib/ChevronLeft';
import ArrowRightXS from '@crehana/crehana-icons/lib/ChevronRight';
import transition from '../../styles/transition';
import {
  white as whiteColor,
  grayMain,
  grayDark,
  primaryMain,
  secondaryLight,
} from '../../styles/colors';
import { IconButtonProps } from './types';
import CLASSNAMES from './classnames';

const Button = styled.button`
  transition: ${transition('border')};
  & path {
    transition: ${transition('fill')};
  }
`;

const IconButton = React.forwardRef<any, IconButtonProps>(
  (
    {
      children,
      as,
      white,
      darkMode,
      arrow,
      xs,
      customIcon,
      customSize,
      customColor,
      responsive,
      disabled,
      href,
      className = '',
      ...other
    },
    ref,
  ) => {
    const Icon = useMemo(() => {
      if (xs) {
        if (arrow === 'left') {
          return ArrowLeftXS;
        }
        if (arrow === 'right') {
          return ArrowRightXS;
        }
      }
      if (arrow === 'left') {
        return ArrowLeft;
      }
      if (arrow === 'right') {
        return ArrowRight;
      }
      return customIcon;
    }, [arrow, customIcon, xs]);

    const defaultTag: keyof JSX.IntrinsicElements = href ? 'a' : 'button';

    const size = customSize || (xs ? 32 : 24);

    let buttonTypeClassNames = CLASSNAMES[
      `default${xs ? '-xs' : ''}${disabled ? '-disabled' : ''}`
    ](responsive);
    let iconColor = disabled ? grayMain : primaryMain;

    if (darkMode) {
      buttonTypeClassNames = CLASSNAMES[
        `darkMode${xs ? '-xs' : ''}${disabled ? '-disabled' : ''}`
      ](responsive);
      iconColor = disabled ? grayDark : secondaryLight;
    }

    if (white) {
      buttonTypeClassNames = CLASSNAMES[
        `white${xs ? '-xs' : ''}${disabled ? '-disabled' : ''}`
      ](responsive);
      iconColor = disabled ? grayDark : whiteColor;
    }

    return (
      <Button
        ref={ref}
        className={cn(buttonTypeClassNames, className)}
        disabled={disabled}
        href={href}
        as={as || defaultTag}
        {...other}
      >
        {Icon ? (
          <Icon size={size} color={customColor || iconColor} />
        ) : (
          children
        )}
      </Button>
    );
  },
);

export default IconButton;
